import Cookies from "js-cookie";

export const isAuth = () => {
  const refreshToken = Cookies.get("REPLHADA_ADMIN_REFRESH_TOKEN");

  return !!refreshToken;
};
